<template>
    <div
        style="
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 3mm;
    "
    >
        <tiss-box
            title="GUIA TRATAMENTO ODONTOLÓGICO"
            :guiaPrestador="numeroGuia"
            :logo="logoURL"
            :operadora="logoText"
            v-if="odonto != null"
        >
            <div class="row mx-1" style="margin-bottom: 1px;">
                <tiss-field
                    title="1 - Registro ANS"
                    largura="10%"
                    :value="registroANS"
                />
                <tiss-field
                    title="3 - Número da Guia Principal"
                    largura="12%"
                    :value="numeroGuiaPrincipal"
                />
                <tiss-field
                    title="4 - Data da Autorização"
                    largura="12%"
                    :value="dataAutorizacao"
                />
                <tiss-field
                    title="5 - Senha"
                    largura="29.7%"
                    :value="senha" />
                <tiss-field
                    title="6 - Validade da Senha"
                    largura="12%"
                    :value="dataValidadeAutorizacao"
                />
                <tiss-field
                    title="7 - Número da Guia na Operadora"
                    largura="18%"
                    :value="numeroGuiaOperadora"
                />
            </div>

            <div class="row">
                <div class="col">
                    <tiss-sub-title
                        title="Dados do Beneficiário"
                    ></tiss-sub-title>
                </div>
            </div>

            <div class="row mx-1" style="margin-bottom: 1px;">
                <tiss-field
                    title="8 - Numero da Carteira"
                    largura="31%"
                    :value="numeroCarteira"
                ></tiss-field>
                <tiss-field
                    title="9 - Plano"
                    largura="25%"
                    :value="planoBeneficiario"
                ></tiss-field>
                <tiss-field
                    title="10 - Empresa"
                    largura="23%"
                    :value="nomeEmpresa"
                ></tiss-field>
                <tiss-field
                    title="11 - Validade da Carteira"
                    largura="16%"
                    :value="validadeCarteira"
                ></tiss-field>
            </div>

            <div class="row mx-1" style="margin-bottom: 1px;">
                <tiss-field
                    title="57 - Nome Social"
                    largura="50%"
                    :value="nomeSocialBeneficario"
                ></tiss-field>
            </div>

            <div class="row mx-1" style="margin-bottom: 1px;">
                <tiss-field
                    title="13 - Nome"
                    largura="50%"
                    :value="nomeBeneficario"
                ></tiss-field>
                <tiss-field
                    title="14 - Telefone"
                    largura="15%"
                ></tiss-field>
                <tiss-field
                    title="15 - Nome do titular do plano"
                    largura="15%"
                ></tiss-field>
                <tiss-field
                    title="16 - atendimentoRN"
                    largura="15%"
                    :value="atendimentoRN"
                ></tiss-field>
            </div>

            <div class="row">
                <div class="col">
                    <tiss-sub-title
                        title="Dados do Contratado Responsável pelo Tratamento"
                    ></tiss-sub-title>
                </div>
            </div>

            <div class="row mx-1" style="margin-bottom: 1px;">
                <tiss-field
                    title="17 - Nome do Profissional Solicitante"
                    largura="55%"
                    :value="nomeProfissional"
                />
                <tiss-field
                    title="18 - Número no CRO"
                    largura="20%"
                    :value="croSolicitante"
                />
                <tiss-field
                    title="19 - UF"
                    largura="9%"
                    :value="ufCroSolic"
                />
                <tiss-field
                    title="20 - Código CBO"
                    largura="11%"
                    :value="cbosSolic"
                />
            </div>

            <div class="row mx-1" style="margin-bottom: 1px;">
                <tiss-field
                    title="21 - Código na Operadora"
                    largura="14.3%"
                    :value="codigoProfissonalExec"
                />
                <tiss-field
                    title="22 - Nome do Contratado Executante"
                    largura="40%"
                    :value="nomeProfissionalExec"
                />
                <tiss-field
                    title="23 - Número no CRO"
                    largura="20%"
                    :value="croProfissionalExec"
                />
                <tiss-field
                    title="24 - UF"
                    largura="9%"
                    :value="ufProfissionalExec"
                />
                <tiss-field
                    title="25 - Código CNES"
                    largura="11%"
                    :value="cnesProfissionalExec"
                />
            </div>

            <div class="row mx-1" style="margin-bottom: 1px;">
                <tiss-field
                    title="26 - Nome do Profissional Executante"
                    largura="55%"
                    :value="nomeProfissionalExec2"
                />
                <tiss-field
                    title="27 - Número no CRO"
                    largura="20%"
                    :value="croProfissionalExec2"
                />
                <tiss-field
                    title="28 - UF"
                    largura="9%"
                    :value="ufProfissionalExec2"
                />
                <tiss-field
                    title="29 - Código CBO"
                    largura="11%"
                    :value="cbosProfissionalExec2"
                />
            </div>

            <div class="row">
                <div class="col">
                    <tiss-sub-title
                        title="Plano de Tratamento / Procedimentos Solicitados / Procedimentos Executados"
                    ></tiss-sub-title>
                </div>
            </div>

            <div class="row mx-1" style="margin-bottom: 1px;">
                <tiss-table
                    largura="98%"
                    altura="5.8cm"
                    :campos="tabelaProcedimentosExecutados"
                    :numeracao="Number('30')"
                    :sizeCampos="[4, 4, 4, 4, 8, 13, 4, 2, 2, 4, 5, 4, 4]"
                    :indice="true"
                />
            </div>

            <div class="row mx-1" style="margin-bottom: 1px;">
                <tiss-field
                    title="43 - Data de Término do Tratamento"
                    largura="14%"
                    :value="dataTerminoTratamento"
                ></tiss-field>
                <tiss-field
                    title="44 - Tipo de Atendimento"
                    largura="12%"
                    :value="tipoAtendimento"
                ></tiss-field>
                <tiss-field
                    title="45 - Tipo de Faturamento"
                    largura="12%"
                    :value="tipoFaturamento"
                ></tiss-field>
                <tiss-field
                    title="46 - Total Quantidade US"
                    largura="14%"
                    :value="totalQuantidadeUS"
                ></tiss-field>
                <tiss-field
                    title="47 - Valor Total (R$)"
                    largura="14%"
                    :value="valorTotal"
                ></tiss-field>
                <tiss-field
                    title="21 - Hora Fim Faturamento"
                    largura="14%"
                    :value="horaFinalFaturamento"
                ></tiss-field>
                <tiss-field
                    title="48 – Valor Total Franquia (R$)"
                    largura="14%"
                    :value="valorTotalFranquia"
                ></tiss-field>
            </div>

            <div class="row mx-1" style="margin-bottom: 1px;">
                <span style="font-size: 8px">
                    Declaro, que após ter sido devidamente esclarecido sobre os propósitos, riscos, custos e alternativas de tratamento, conforme acima apresentados, aceito e autorizo a execução do tratamento, comprometendo-me a cumprir as orientações do profissional assistente e arcar com os custos previstos em contrato. Declaro, ainda, que o(s) procedimento(s) descrito(s) acima, e por mim assinado(s), foi/foram realizado(s) com meu consentimento e de forma satisfatória. Autorizo a Operadora a pagar em meu nome e por minha conta, ao profissional contratado que assina esse documento, os valores referentes ao tratamento realizado, comprometendo-me a arcar com os custos conforme previsto em contrato.
                </span>
            </div>

            <div class="row mx-1" style="margin-bottom: 1px;">
                <tiss-field
                    title="49 - Observação/Justificativa"
                    largura="98%"
                    altura="1.0cm"
                    :value="observacao"
                    :obrigatorio="false"
                />
            </div>

            <div class="row mx-1 mb-0">
                <tiss-field
                    title="50 - Data da Assinatura do Cirurgião-Dentista Solicitante"
                    largura="26%"
                ></tiss-field>
                <tiss-field
                    title="51 - Assinatura do Cirurgião-Dentista Solicitante"
                    largura="26%"
                ></tiss-field>
                <tiss-field
                    title="52 - Data da assinatura do Cirurgião-Dentista"
                    largura="22%"
                ></tiss-field>
                <tiss-field
                    title="53 - Assinatura do Cirurgião-Dentista"
                    largura="22%"
                ></tiss-field>
            </div>

            <div class="row mx-1 mb-0">
                <tiss-field
                    title="54 - Data da assinatura do Beneficiário ou Responsável"
                    largura="26%"
                ></tiss-field>
                <tiss-field
                    title="55 - Assinatura do Beneficiário ou Responsável"
                    largura="26%"
                ></tiss-field>
            </div>

            <div class="row mx-1">
                <div class="col">
                    <tiss-rodape
                        :infoId="this.guia.id_atendimento"
                        :idExterno="this.guia.st_id_externo"
                        :responsavel="atendimento_usuario()"
                        :pageIndex="pageIndex"
                        :pageCount="pageCount"
                    ></tiss-rodape>
                </div>
            </div>

        </tiss-box>
    </div>
</template>

<script>
// import * as moment from "moment";
import _ from "lodash";
import TissTable from "./TissTable.vue";
import TissBox from "./TissBox.vue";
import TissField from "./TissField.vue";
import TissSubTitle from "./TissSubTitle.vue";
// import TissAssinaturas from "./TissAssinaturas.vue";
import TissRodape from "./TissRodape";

export default {
    data() {
        return {
            largura: "21cm",
            larguramm: 200
        };
    },
    methods: {
        clargura(perc = 100) {
            let larg = this.larguramm - 20;
            larg = Math.round(larg * (perc / 100));
            return larg + "mm";
        },
        atendimento_usuario() {
            if (this.guia && this.guia.st_login) {
                return this.guia.st_login;
            }

            return null;
        },
        ocultar_valores() {
            return this.guia && this.guia.ocultar_valores;
        }
    },
    computed: {
        nomeContratadoAss: function() {
            if (!this.nome_contratado_ass) {
                return "";
            }

            return this.nomeContratadoExecutante;
        },

        logoURL: function() {
            if (this.guia && this.guia.logo_url_front) {
                return this.guia.logo_url_front;
            }

            if (this.guia && this.guia.logo_text_front) {
                return null;
            }

            return this.logo
        },

        logoText: function() {
            if (this.guia && this.guia.logo_text_front) {
                return this.guia.logo_text_front;
            }

            return this.operadora ? this.operadora.search : '';
        },

        odonto: function() {
            if (this.guia != null && this.guia.mensagemTISS != null) {
                return this.guia.mensagemTISS;
            }
            return null;
        },

        procedimentos: function() {
            let array = [];
            if (
                !Array.isArray(
                    this.odonto.prestadorParaOperadora.loteGuias.guiasTISS
                        .guiaOdonto.procedimentosExecutados
                )
            ) {
                array[0] = this.odonto.prestadorParaOperadora.loteGuias.guiasTISS.guiaOdonto.procedimentosExecutados;
            } else
                array = this.odonto.prestadorParaOperadora.loteGuias.guiasTISS
                    .guiaOdonto.procedimentosExecutados;
            return array;
        },
        valorPago() {
            let valor = {};
            if (
                Array.isArray(
                    this.odonto.prestadorParaOperadora.loteGuias.guiasTISS
                        .guiaOdonto.valorTotal
                )
            ) {
                valor = this.odonto.prestadorParaOperadora.loteGuias.guiasTISS
                    .guiaOdonto.valorTotal[0];
            } else
                valor = this.odonto.prestadorParaOperadora.loteGuias.guiasTISS
                    .guiaOdonto.valorTotal;
            return valor;
        },
        registroANS: function() {
            return  _.get(this.odonto, 'prestadorParaOperadora.loteGuias.guiasTISS.guiaOdonto.registroANS', '');
        },
        numeroGuiaPrincipal: function() {
            return  _.get(this.odonto, 'prestadorParaOperadora.loteGuias.guiasTISS.guiaOdonto.numeroGuiaPrincipal', '');
        },
        numeroGuiaSolicitacaoInternacao: function() {
            if (
                this.odonto.prestadorParaOperadora.loteGuias.guiasTISS
                    .guiaOdonto &&
                this.odonto.prestadorParaOperadora.loteGuias.guiasTISS
                    .guiaOdonto.numeroGuiaSolicitacaoInternacao
            )
                return this.odonto.prestadorParaOperadora.loteGuias.guiasTISS
                    .guiaOdonto.numeroGuiaSolicitacaoInternacao;
            else return "";
        },
        numeroGuia: function() {
            if (
                this.odonto.prestadorParaOperadora.loteGuias.guiasTISS
                    .guiaOdonto.cabecalhoGuia &&
                this.odonto.prestadorParaOperadora.loteGuias.guiasTISS
                    .guiaOdonto.cabecalhoGuia.numeroGuiaPrestador
            )
                return this.odonto.prestadorParaOperadora.loteGuias.guiasTISS
                    .guiaOdonto.cabecalhoGuia.numeroGuiaPrestador;
            else return "";
        },
        senha: function() {
            let data =_.get(this.odonto, 'prestadorParaOperadora.loteGuias.guiasTISS.guiaOdonto.senhaAutorizacao', '');

            if (data.length > 30) data = data.substring(0, 30) + "...";

            return data;
        },
        dataAutorizacao: function() {
            let data =_.get(this.odonto, 'prestadorParaOperadora.loteGuias.guiasTISS.guiaOdonto.dataAutorizacao', '');

            if (data && !Array.isArray(data)) {
                data = this.$util.getFormatDate(data);
            }
            return data;
        },
        dataValidadeAutorizacao: function() {
            let data =_.get(this.odonto, 'prestadorParaOperadora.loteGuias.guiasTISS.guiaOdonto.validadeSenha', '');

            if (data && !Array.isArray(data)) {
                data = this.$util.getFormatDate(data);
            }
            return data;
        },
        numeroGuiaOperadora: function() {
            if (this.guia && this.guia.st_numero) {
                return this.guia.st_numero;
            }

            return null;
        },
        numeroCarteira: function() {
            let data =_.get(this.odonto, 'prestadorParaOperadora.loteGuias.guiasTISS.guiaOdonto.beneficiario.numeroCarteira', '');

            return data;
        },
        planoBeneficiario: function() {
            let data =_.get(this.odonto, 'prestadorParaOperadora.loteGuias.guiasTISS.guiaOdonto.planoBeneficiario', '');

            return data;
        },
        nomeEmpresa: function() {
            let data =_.get(this.odonto, 'prestadorParaOperadora.loteGuias.guiasTISS.guiaOdonto.nomeEmpresa', '');

            return data;
        },
        validadeCarteira: function() {
            if (this.guia.dt_validade_carteira) {
                return this.$util.getFormatDate(
                    this.guia.dt_validade_carteira,
                    "DD/MM/YYYY"
                );
            }
            return "";
        },
        atendimentoRN: function() {
            let data =_.get(this.odonto, 'prestadorParaOperadora.loteGuias.guiasTISS.guiaOdonto.beneficiario.atendimentoRN', '');

            return data;
        },
        nomeBeneficario: function() {
            let data =_.get(this.odonto, 'prestadorParaOperadora.loteGuias.guiasTISS.guiaOdonto.beneficiario.nomeBeneficiario', '');

            return data;
        },
        nomeSocialBeneficario: function() {
            let data =_.get(this.odonto, 'prestadorParaOperadora.loteGuias.guiasTISS.guiaOdonto.beneficiario.nomeSocialBeneficiario', '');

            if(!data || Array.isArray(data)) return '';

            return data;
        },
        codigoPrestadorNaOperadora: function() {
            let codPrestador = "";
            if (
                this.odonto.prestadorParaOperadora.loteGuias.guiasTISS
                    .guiaOdonto.dadosSolicitante &&
                this.odonto.prestadorParaOperadora.loteGuias.guiasTISS
                    .guiaOdonto.dadosSolicitante.contratadoSolicitante
            ) {
                if (
                    this.odonto.prestadorParaOperadora.loteGuias.guiasTISS
                        .guiaOdonto.dadosSolicitante.contratadoSolicitante
                        .cnpjContratado
                ) {
                    codPrestador = this.odonto.prestadorParaOperadora.loteGuias
                        .guiasTISS.guiaOdonto.dadosSolicitante
                        .contratadoSolicitante.cnpjContratado;
                } else if (
                    this.odonto.prestadorParaOperadora.loteGuias.guiasTISS
                        .guiaOdonto.dadosSolicitante.contratadoSolicitante
                        .cpfContratado
                ) {
                    codPrestador = this.odonto.prestadorParaOperadora.loteGuias
                        .guiasTISS.guiaOdonto.dadosSolicitante
                        .contratadoSolicitante.cpfContratado;
                } else if (
                    this.odonto.prestadorParaOperadora.loteGuias.guiasTISS
                        .guiaOdonto.dadosSolicitante.contratadoSolicitante
                        .codigoPrestadorNaOperadora
                ) {
                    codPrestador = this.odonto.prestadorParaOperadora.loteGuias
                        .guiasTISS.guiaOdonto.dadosSolicitante
                        .contratadoSolicitante.codigoPrestadorNaOperadora;
                }
            }
            return codPrestador;
        },
        nomeContratado: function() {
            return this.odonto.prestadorParaOperadora.loteGuias.guiasTISS
                .guiaOdonto.dadosSolicitante &&
                this.odonto.prestadorParaOperadora.loteGuias.guiasTISS
                    .guiaOdonto.dadosSolicitante.contratadoSolicitante &&
                this.odonto.prestadorParaOperadora.loteGuias.guiasTISS
                    .guiaOdonto.dadosSolicitante.contratadoSolicitante
                    .nomeContratado
                ? this.odonto.prestadorParaOperadora.loteGuias.guiasTISS
                      .guiaOdonto.dadosSolicitante.contratadoSolicitante
                      .nomeContratado
                : "";
        },
        nomeProfissional: function() {
            let data =_.get(this.odonto, 'prestadorParaOperadora.loteGuias.guiasTISS.guiaOdonto.dadosProfissionaisResponsaveis.nomeProfSolic', '');

            return data;
        },
        croSolicitante: function() {
            let data =_.get(this.odonto, 'prestadorParaOperadora.loteGuias.guiasTISS.guiaOdonto.dadosProfissionaisResponsaveis.croSolic', '');

            return data;
        },
        ufCroSolic: function() {
            let data =_.get(this.odonto, 'prestadorParaOperadora.loteGuias.guiasTISS.guiaOdonto.dadosProfissionaisResponsaveis.ufSolic', '');

            return data;
        },
        cbosSolic: function() {
            let data =_.get(this.odonto, 'prestadorParaOperadora.loteGuias.guiasTISS.guiaOdonto.dadosProfissionaisResponsaveis.cbosSolic', '');

            return data;
        },
        dataTerminoTratamento: function() {
            let data =_.get(this.odonto, 'prestadorParaOperadora.loteGuias.guiasTISS.guiaOdonto.dataTerminoTrat', '');

            return data;
        },
        tipoAtendimento: function() {
            let data =_.get(this.odonto, 'prestadorParaOperadora.loteGuias.guiasTISS.guiaOdonto.tipoAtendimento', '');

            return data;
        },
        tipoFaturamento: function() {
            let data =_.get(this.odonto, 'prestadorParaOperadora.loteGuias.guiasTISS.guiaOdonto.tipoFaturamento', '');

            return data;
        },
        totalQuantidadeUS: function() {
            let data =_.get(this.odonto, 'prestadorParaOperadora.loteGuias.guiasTISS.guiaOdonto.qtdTotalUS', '');

            return data;
        },
        valorTotal: function() {
            let data = this.$util.formatMoeda(_.get(this.odonto, 'prestadorParaOperadora.loteGuias.guiasTISS.guiaOdonto.valorTotalProc', 0));

            return data;
        },
        valorTotalFranquia: function() {
            let data = this.$util.formatMoeda(_.get(this.odonto, 'prestadorParaOperadora.loteGuias.guiasTISS.guiaOdonto.valorTotalFranquia', 0));

            return data;
        },
        numeroConselhoProfissional: function() {
            return this.odonto.prestadorParaOperadora.loteGuias.guiasTISS
                .guiaOdonto.dadosSolicitante &&
                this.odonto.prestadorParaOperadora.loteGuias.guiasTISS
                    .guiaOdonto.dadosSolicitante.profissionalSolicitante &&
                this.odonto.prestadorParaOperadora.loteGuias.guiasTISS
                    .guiaOdonto.dadosSolicitante.profissionalSolicitante
                    .conselhoProfissional
                ? this.odonto.prestadorParaOperadora.loteGuias.guiasTISS
                      .guiaOdonto.dadosSolicitante.profissionalSolicitante
                      .conselhoProfissional
                : "";
        },
        conselhoProfissional: function() {
            return this.odonto.prestadorParaOperadora.loteGuias.guiasTISS
                .guiaOdonto.dadosSolicitante &&
                this.odonto.prestadorParaOperadora.loteGuias.guiasTISS
                    .guiaOdonto.dadosSolicitante.profissionalSolicitante &&
                this.odonto.prestadorParaOperadora.loteGuias.guiasTISS
                    .guiaOdonto.dadosSolicitante.profissionalSolicitante
                    .numeroConselhoProfissional
                ? this.odonto.prestadorParaOperadora.loteGuias.guiasTISS
                      .guiaOdonto.dadosSolicitante.profissionalSolicitante
                      .numeroConselhoProfissional
                : "";
        },
        UF: function() {
            return this.odonto.prestadorParaOperadora.loteGuias.guiasTISS
                .guiaOdonto.dadosSolicitante &&
                this.odonto.prestadorParaOperadora.loteGuias.guiasTISS
                    .guiaOdonto.dadosSolicitante.profissionalSolicitante &&
                this.odonto.prestadorParaOperadora.loteGuias.guiasTISS
                    .guiaOdonto.dadosSolicitante.profissionalSolicitante.UF
                ? this.$util.siglaUF(
                      this.odonto.prestadorParaOperadora.loteGuias.guiasTISS
                          .guiaOdonto.dadosSolicitante.profissionalSolicitante
                          .UF
                  )
                : "";
        },

        cbos: function() {
            return this.odonto.prestadorParaOperadora.loteGuias.guiasTISS
                .guiaOdonto.dadosSolicitante &&
                this.odonto.prestadorParaOperadora.loteGuias.guiasTISS
                    .guiaOdonto.dadosSolicitante.profissionalSolicitante &&
                this.odonto.prestadorParaOperadora.loteGuias.guiasTISS
                    .guiaOdonto.dadosSolicitante.profissionalSolicitante.CBOS
                ? this.odonto.prestadorParaOperadora.loteGuias.guiasTISS
                      .guiaOdonto.dadosSolicitante.profissionalSolicitante.CBOS
                : "";
        },

        dataSolicitacao: function() {
            return this.odonto.prestadorParaOperadora.loteGuias.guiasTISS
                .guiaOdonto.dadosSolicitacao &&
                this.odonto.prestadorParaOperadora.loteGuias.guiasTISS
                    .guiaOdonto.dadosSolicitacao.dataSolicitacao
                ? this.$util.getFormatDate(
                      this.odonto.prestadorParaOperadora.loteGuias.guiasTISS
                          .guiaOdonto.dadosSolicitacao.dataSolicitacao,
                      "DD/MM/YYYY"
                  )
                : "";
        },
        caraterAtendimento: function() {
            return this.odonto.prestadorParaOperadora.loteGuias.guiasTISS
                .guiaOdonto.dadosInternacao &&
                this.odonto.prestadorParaOperadora.loteGuias.guiasTISS
                    .guiaOdonto.dadosInternacao.caraterAtendimento
                ? this.odonto.prestadorParaOperadora.loteGuias.guiasTISS
                      .guiaOdonto.dadosInternacao.caraterAtendimento
                : "";
        },
        dataInicioFaturamento: function() {
            return this.odonto.prestadorParaOperadora.loteGuias.guiasTISS
                .guiaOdonto.dadosInternacao &&
                this.odonto.prestadorParaOperadora.loteGuias.guiasTISS
                    .guiaOdonto.dadosInternacao.dataInicioFaturamento
                ? this.$util.getFormatDate(
                      this.odonto.prestadorParaOperadora.loteGuias.guiasTISS
                          .guiaOdonto.dadosInternacao.dataInicioFaturamento,
                      "DD/MM/YYYY"
                  )
                : "";
        },
        horaInicioFaturamento: function() {
            return this.odonto.prestadorParaOperadora.loteGuias.guiasTISS
                .guiaOdonto.dadosInternacao &&
                this.odonto.prestadorParaOperadora.loteGuias.guiasTISS
                    .guiaOdonto.dadosInternacao.horaInicioFaturamento
                ? this.odonto.prestadorParaOperadora.loteGuias.guiasTISS
                      .guiaOdonto.dadosInternacao.horaInicioFaturamento
                : "";
        },
        dataFinalFaturamento: function() {
            return this.odonto.prestadorParaOperadora.loteGuias.guiasTISS
                .guiaOdonto.dadosInternacao &&
                this.odonto.prestadorParaOperadora.loteGuias.guiasTISS
                    .guiaOdonto.dadosInternacao.dataFinalFaturamento
                ? this.$util.getFormatDate(
                      this.odonto.prestadorParaOperadora.loteGuias.guiasTISS
                          .guiaOdonto.dadosInternacao.dataFinalFaturamento,
                      "DD/MM/YYYY"
                  )
                : "";
        },
        horaFinalFaturamento: function() {
            return this.odonto.prestadorParaOperadora.loteGuias.guiasTISS
                .guiaOdonto.dadosInternacao &&
                this.odonto.prestadorParaOperadora.loteGuias.guiasTISS
                    .guiaOdonto.dadosInternacao.horaFinalFaturamento
                ? this.odonto.prestadorParaOperadora.loteGuias.guiasTISS
                      .guiaOdonto.dadosInternacao.horaFinalFaturamento
                : "";
        },
        tipoInternacao: function() {
            return this.odonto.prestadorParaOperadora.loteGuias.guiasTISS
                .guiaOdonto.dadosInternacao &&
                this.odonto.prestadorParaOperadora.loteGuias.guiasTISS
                    .guiaOdonto.dadosInternacao.tipoInternacao
                ? this.odonto.prestadorParaOperadora.loteGuias.guiasTISS
                      .guiaOdonto.dadosInternacao.tipoInternacao
                : "";
        },
        regimeInternacao: function() {
            return this.odonto.prestadorParaOperadora.loteGuias.guiasTISS
                .guiaOdonto.dadosInternacao &&
                this.odonto.prestadorParaOperadora.loteGuias.guiasTISS
                    .guiaOdonto.dadosInternacao.regimeInternacao
                ? this.odonto.prestadorParaOperadora.loteGuias.guiasTISS
                      .guiaOdonto.dadosInternacao.regimeInternacao
                : "";
        },

        indicacao: function() {
            if (
                this.odonto.prestadorParaOperadora.loteGuias.guiasTISS
                    .guiaOdonto.dadosSolicitacao &&
                this.odonto.prestadorParaOperadora.loteGuias.guiasTISS
                    .guiaOdonto.dadosSolicitacao.indicacaoClinica
            )
                return this.odonto.prestadorParaOperadora.loteGuias.guiasTISS
                    .guiaOdonto.dadosSolicitacao.indicacaoClinica;
            return "";
        },

        codigoProfissonalExec: function() {
            let data =_.get(this.odonto, 'prestadorParaOperadora.loteGuias.guiasTISS.guiaOdonto.dadosProfissionaisResponsaveis.codigoProfExec', '');

            return data;
        },
        nomeProfissionalExec: function() {
            let data =_.get(this.odonto, 'prestadorParaOperadora.loteGuias.guiasTISS.guiaOdonto.dadosProfissionaisResponsaveis.nomeProfExec', '');

            return data;
        },
        croProfissionalExec: function() {
            let data =_.get(this.odonto, 'prestadorParaOperadora.loteGuias.guiasTISS.guiaOdonto.dadosProfissionaisResponsaveis.croExec', '');

            return data;
        },
        ufProfissionalExec: function() {
            let data =_.get(this.odonto, 'prestadorParaOperadora.loteGuias.guiasTISS.guiaOdonto.dadosProfissionaisResponsaveis.ufExec', '');

            return data;
        },
        cnesProfissionalExec: function() {
            let data =_.get(this.odonto, 'prestadorParaOperadora.loteGuias.guiasTISS.guiaOdonto.dadosProfissionaisResponsaveis.cnesExec', '');

            return data;
        },
        nomeProfissionalExec2: function() {
            let data =_.get(this.odonto, 'prestadorParaOperadora.loteGuias.guiasTISS.guiaOdonto.dadosProfissionaisResponsaveis.nomeProfExec2', '');

            return data;
        },
        croProfissionalExec2: function() {
            let data =_.get(this.odonto, 'prestadorParaOperadora.loteGuias.guiasTISS.guiaOdonto.dadosProfissionaisResponsaveis.croExec2', '');

            return data;
        },
        ufProfissionalExec2: function() {
            let data =_.get(this.odonto, 'prestadorParaOperadora.loteGuias.guiasTISS.guiaOdonto.dadosProfissionaisResponsaveis.ufExec2', '');

            return data;
        },
        cbosProfissionalExec2: function() {
            let data =_.get(this.odonto, 'prestadorParaOperadora.loteGuias.guiasTISS.guiaOdonto.dadosProfissionaisResponsaveis.cbosExec2', '');

            return data;
        },
        dataExecução: function() {
            return this.odonto.prestadorParaOperadora.loteGuias.guiasTISS
                .guiaOdonto.procedimentosExecutados &&
                this.odonto.prestadorParaOperadora.loteGuias.guiasTISS
                    .guiaOdonto.procedimentosExecutados.procedimentoExecutado &&
                this.odonto.prestadorParaOperadora.loteGuias.guiasTISS
                    .guiaOdonto.procedimentosExecutados.procedimentoExecutado
                    .dataExecução
                ? this.odonto.prestadorParaOperadora.loteGuias.guiasTISS
                      .guiaOdonto.procedimentosExecutados.procedimentoExecutado
                      .dataExecução
                : "";
        },

        observacao: function() {
            let data =_.get(this.odonto, 'prestadorParaOperadora.loteGuias.guiasTISS.guiaOdonto.observacao', '');

            return data;
        },

        tabelaProcedimentosExecutados: function() {
            let campos = [];
            let procs = this.procedimentos;
            for (let i = 0; i < procs.length; i++) {
                let tmp = {};

                if (!procs[i]) continue;

                tmp["Tabela"] = _.get(procs[i], "procSolic.codigoTabela", "")
                tmp["Código do Procedimento"] = _.get(procs[i], "procSolic.codigoProcedimento", "");
                tmp["Descrição"] = _.get(procs[i], "procSolic.descricaoProcedimento", "");
                tmp["Dente/Região"] = _.get(procs[i], "denteRegiao.codDente", "") + _.get(procs[i], "denteRegiao.codRegiao", "");
                tmp["Face"] = _.get(procs[i], "denteFace", "");
                tmp["Qtde"] = _.get(procs[i], "qtdProc", "");
                tmp["Qtde US"] = _.get(procs[i], "qtdUS", "");
                tmp["Valor R$"] = _.get(procs[i], "valorProc", "") ? this.$util.formatMoeda(_.get(procs[i], "valorProc", 0)) : "";
                tmp["Franquia (R$)"] = _.get(procs[i], "valorFranquia", "") ? this.$util.formatMoeda(_.get(procs[i], "valorFranquia", 0)) : "";
                tmp["Aut"] = _.get(procs[i], "autorizado", "");
                tmp["Cod. Negativa"] = "";
                tmp["Data de Realização"] = this.$util.getFormatDate(_.get(procs[i], "dataRealizacao", ""), "DD/MM/YYYY");
                tmp["Assinatura"] = "";

                campos.push(tmp);
            }

            return campos;
        },
        tabelaProfissionaisExecutantes: function() {
            let campos = [];
            // let procedimentos = this.odonto.prestadorParaOperadora.loteGuias
            //   .guiasTISS.guiaOdonto.procedimentosExecutados.procedimentoExecutado;
            let procedimentos = this.procedimentos;

            for (var i = 0; i < procedimentos.length; i++) {
                let tmp = {};
                tmp["Seq. Ref."] = "";

                if (!procedimentos[i]) continue;

                if (procedimentos[i].identEquipe.identificacaoEquipe.grauPart) {
                    tmp["Grau Part."] =
                        procedimentos[
                            i
                        ].identEquipe.identificacaoEquipe.grauPart;
                } else tmp["Grau Part."] = "";

                if (
                    procedimentos[i].identEquipe.identificacaoEquipe
                        .codProfissional.cpfContratado
                ) {
                    tmp["Código na Operadora/CPF"] =
                        procedimentos[
                            i
                        ].identEquipe.identificacaoEquipe.codProfissional.cpfContratado;
                } else if (
                    procedimentos[i].identEquipe.identificacaoEquipe
                        .codProfissional.codigoPrestadorNaOperadora
                ) {
                    tmp["Código na Operadora/CPF"] =
                        procedimentos[
                            i
                        ].identEquipe.identificacaoEquipe.codProfissional.codigoPrestadorNaOperadora;
                } else tmp["Código na Operadora/CPF"] = "";

                if (procedimentos[i].identEquipe.identificacaoEquipe.nomeProf)
                    tmp["Nome do Profissional"] =
                        procedimentos[
                            i
                        ].identEquipe.identificacaoEquipe.nomeProf;
                else tmp["Nome do Profissional"] = "";

                if (procedimentos[i].identEquipe.identificacaoEquipe.conselho)
                    tmp["Conselho Profissional"] =
                        procedimentos[
                            i
                        ].identEquipe.identificacaoEquipe.conselho;
                else tmp["Conselho Profissional"] = "";

                if (
                    procedimentos[i].identEquipe.identificacaoEquipe
                        .numeroConselhoProfissional
                )
                    tmp["Número no Conselho"] =
                        procedimentos[
                            i
                        ].identEquipe.identificacaoEquipe.numeroConselhoProfissional;
                else tmp["Número no Conselho"] = "";

                if (
                    procedimentos[i].identEquipe.identificacaoEquipe &&
                    procedimentos[i].identEquipe.identificacaoEquipe.UF
                )
                    tmp["UF"] = this.$util.siglaUF(
                        procedimentos[i].identEquipe.identificacaoEquipe.UF
                    );
                else tmp["UF"] = "";

                if (
                    procedimentos[i].identEquipe.identificacaoEquipe &&
                    procedimentos[i].identEquipe.identificacaoEquipe.CBOS
                )
                    tmp["Código CBO"] =
                        procedimentos[i].identEquipe.identificacaoEquipe.CBOS;
                else tmp["Código CBO"] = "";

                campos.push(tmp);
            }

            return campos;
        },

        styleRotate() {
            if (this.rotate)
                return "transform: rotate(270deg) translate(-376mm, 0); transform-origin: 0 0; margin: 0; padding: 0;";
            //return "-webkit-transform: rotate(-90deg) !important;-moz-transform:rotate(-90deg) !important;-o-transform: rotate(-90deg) !important; -ms-transform:rotate(-90deg) !important;position:relative;top:15cm;left:0px; padding:1cm;";
            //return "-webkit-transform: rotate(-90deg) scale(.65,.65) !important;-moz-transform:rotate(-90deg) scale(.58,.58)!important;-o-transform: rotate(-90deg) scale(.58,.58)!important; -ms-transform:rotate(-90deg) scale(.6,.6)!important;position:relative;top:10cm;left:0px; padding:1cm;";
            return "";
        }
    },
    props: [
        "guia",
        "logo",
        "operadora",
        "rotate",
        "nome_contratado_ass",
        "pageIndex",
        "pageCount"
    ],
    components: {
        TissTable,
        TissBox,
        TissField,
        TissSubTitle,
        // TissAssinaturas,
        TissRodape
    }
};
</script>

<style></style>
